/**
 * 模态框键值常量
 * 用于在整个应用中统一引用模态框标识符
 */
const MODAL_KEYS = {
    // 主要模态框
    TRANSACTION: "transaction", // 事务处理模态框
    // AI_ACTION: "aiAction", // AI动作模态框 - 已移除
    FLIGHT_DETAIL: "flightDetail", // 航班详情模态框
    ENHANCED_FLIGHT_TIMES: "enhancedFlightTimes", // 增强航班时间模态框
    // FLIGHT_DETAIL_PANEL: "flightDetailPanel", // 移除或注释掉面板键

    // 事务类型
    TRANSACTION_FUEL: "fuel", // 燃油事务
    TRANSACTION_PERMIT: "permit", // 许可事务
    TRANSACTION_CATERING: "catering", // 配餐事务
    TRANSACTION_BRIEF: "brief", // 简报事务
    TRANSACTION_DISPATCH: "dispatch", // 签派通知事务
};

export default MODAL_KEYS;
